import { MyCareerPlan } from './../../../Components/Career/EmployeeCareerPlan/myCareerPlan'
import { Header } from './../../../Components/Career/Header'

export function EmployeeCareerView() {
	return (
		<div className='tw-mr-8'>
			<MyCareerPlan />
		</div>
	)
}
